import { render } from "./transporterCreate.vue?vue&type=template&id=e0542f92&scoped=true"
import script from "./transporterCreate.vue?vue&type=script&lang=js"
export * from "./transporterCreate.vue?vue&type=script&lang=js"

import "./transporterCreate.vue?vue&type=style&index=0&id=e0542f92&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0542f92"]])

export default __exports__